import BaseService from '../core/service/BaseService';

const url = 'avaliacoes-metas';
class AnalisePropostaMetaService extends BaseService {
    getPesquisarUrl(pagination) {
        return { url: `${url}/find-list`, pagination };
    }

    async salvar({ registro }) {
        const { id, manifestacao, flagValidacao } = registro;
        const response = await window.$http.put(`${url}/${id}`, {
            id: id,
            descManifestacaoTecnica: manifestacao,
            parecerMeta: flagValidacao,
        });
        return response;
    }
}

export default new AnalisePropostaMetaService(url, 'id', [{ field: 'id', order: 'desc' }]);
